import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import { FormWrapper, DesktopStepper } from 'components/elements';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function DesktopStepperForm({ activeStep, steps, navigation, children }) {
  const classes = useStyles();
  return (
    <Box display="flex" justifyContent="space-between" className={classes.desktopStepperForm}>
      <Box>
        <DesktopStepper activeStep={activeStep} steps={steps} />
      </Box>
      <Box width="100%">
        <FormWrapper activeStep={activeStep} navigation={navigation} parentClassName={classes.desktopFormWrapper}>
          {children}
        </FormWrapper>
      </Box>
    </Box>
  );
}

DesktopStepperForm.propTypes = {
  activeStep: PropTypes.number.isRequired,
  navigation: PropTypes.element.isRequired,
  children: PropTypes.element.isRequired,
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default DesktopStepperForm;
